import styled from "styled-components";

export const StyledExchangePairsWrapper = styled.div`
  .exchange-pairs-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }

  .apply-to-wrapper {
    margin: 0;
  }
`;